import { Skeleton } from '@/components/ui/misc'

/**
 * Shown while a lazy-loaded route chunk is downloading.
 * Keep it light so it doesn't flash for cached routes.
 */
export function RouteFallback() {
  return (
    <div className="space-y-4 p-1">
      <Skeleton className="h-8 w-64" />
      <Skeleton className="h-4 w-96" />
      <div className="grid gap-3 sm:grid-cols-3">
        {Array.from({ length: 3 }).map((_, i) => <Skeleton key={i} className="h-24" />)}
      </div>
      <Skeleton className="h-64 w-full" />
    </div>
  )
}
